import type { MaintenanceRequestRow, MaintenanceStatus } from '@routeback/core';

export const CATEGORIES = [
  'Brakes', 'Lights', 'Tires / wheels', 'Engine / warning light', 'Door / liftgate',
  'Heat / A/C', 'Body damage', 'Mirrors / glass', 'Camera / electronics', 'Other',
] as const;

export const MAX_PHOTOS = 5;

export const STATUS_LABEL: Record<MaintenanceStatus, string> = {
  submitted: 'Sent',
  acknowledged: 'Seen by manager',
  in_progress: 'Being fixed',
  done: 'Fixed',
  declined: 'Not needed',
  cancelled: 'Cancelled',
};

/** Still waiting on someone (shown at the top, counted as open). */
export const OPEN: readonly MaintenanceStatus[] = ['submitted', 'acknowledged', 'in_progress'];

/**
 * The plugin's duplicate check: an open report on the same truck in the last
 * 7 days. Returned so the driver can see it before sending another.
 */
export function findOpenDuplicate(
  all: MaintenanceRequestRow[],
  truckId: string | null,
  now: number = Date.now(),
): MaintenanceRequestRow | undefined {
  if (!truckId) return undefined;
  const week = 7 * 24 * 3600 * 1000;
  return all
    .filter((r) => !r.deleted_at && r.truck_id === truckId && OPEN.includes(r.status) && now - new Date(r.created_at).getTime() < week)
    .sort((a, b) => b.created_at.localeCompare(a.created_at))[0];
}
